import { getDeleteFollowUrl } from '@core/api'
import { httpClient } from '@core/http-client'

export const deleteFollow = (username: string) => {
    return httpClient.delete(getDeleteFollowUrl(username)).json<{ date_unfollowed: number }>()
}
